import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { GDPRManager } from './../managers/gdpr.manager';

@Injectable()
export class AuthGuard implements CanActivate {
    // tslint:disable-next-line:max-line-length
    constructor(public mgr: GDPRManager, public routeParams: ActivatedRoute ) { }

    canActivate(): boolean {
        this.routeParams.queryParams.subscribe(params => {
            this.mgr.addId = params['addId'];
            this.mgr.platformType = params['platformType'];
            return this.isLoggedIn();
          });
        return true;
    }


    isLoggedIn() {
        if (this.mgr.getGToken()) {
            return true;
        } else {
            this.mgr.reAuthenticate();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/authGuard.service.ts